// Angular imports
import { Component, OnDestroy, OnInit } from '@angular/core';

// Component imports
import { MPBaseWorkspaceManagerComponent } from '../../_base/mp-base-workspace-manager';

// Service imports
import { CiraHelpService } from '../../_services/shared-services/cira-help.service';
import { ContextManagerService } from '../../_services/data-services/context-manager.service';
import { NavigationService } from '../../_services/shared-services/navigation.service';
import { DynamicDashboardService } from '../../dashboard-module/_services/dynamic-dashboard.service';

// Constant imports
import { CiraHelpKeyConstants } from '../../_constants/cira-help-key-constants';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent extends MPBaseWorkspaceManagerComponent implements OnInit, OnDestroy {
    constructor(
        protected readonly ciraHelpService: CiraHelpService,
        protected readonly contextService: ContextManagerService,
        protected readonly navigationService: NavigationService,
        protected readonly dashboardService: DynamicDashboardService
    ) {
        super(
            CiraHelpKeyConstants.applicationHome,
            ciraHelpService,
            contextService,
            navigationService,
            dashboardService
        );
    }

    protected getParentNodeId(): string {
        return `t1`;
    }

    protected getAccessCode(): string {
        return 'HOME';
    }
}
